import {PriceModel} from '../Price.model';
import {ApplicationError} from '@wix/auto_sdk_ecom_current-cart';
import {MINIMUM_ORDER_AMOUNT_NOT_REACHED} from '../../../common/constants';
import {ModelContext} from '../../../types/app.types';

export class MinimumOrderAmountModel {
  public reached: boolean;
  public minAmount: PriceModel;
  public additionalAmount: PriceModel;

  constructor(params: MinimumOrderAmountModel) {
    this.reached = params.reached;
    this.minAmount = params.minAmount;
    this.additionalAmount = params.additionalAmount;
  }

  public static fromCartV1(orderValidationErrors: ApplicationError[], modelContext: ModelContext) {
    const minimumOrderError = orderValidationErrors?.find(
      (validationError) => validationError.code === MINIMUM_ORDER_AMOUNT_NOT_REACHED
    );
    if (!minimumOrderError) {
      return new MinimumOrderAmountModel({
        reached: true,
        minAmount: undefined,
        additionalAmount: undefined,
      });
    }
    return new MinimumOrderAmountModel({
      reached: false,
      additionalAmount: PriceModel.fromCartV1(minimumOrderError.data.remaining, modelContext),
      minAmount: PriceModel.fromCartV1(minimumOrderError.data.minimumOrderAmount, modelContext),
    });
  }
}
